<template>
    <div>
        <div class="d-flex" id="content-wrapper">
            <Sidebar :should-render="showBottomBar" />
            <!-- <Mobilebar :should-render="showMobile" @close="closeMobileBar()" /> -->

            <div class="w-100 ml-3">
                <nav id="mainNav" class="navbar navbar-expand-sm  navbar-dark navbar-expand-md  justify-content-left">
                    <a class="navbar-brand" v-if="showLogo"><img class="img-fluid" src="@/assets/logo.png"
                            width="120"></a>
                    <a v-if="!showLogo" class="nav-link click menu-items d-flex align-items-center justify-content-left"
                        href="#" @click="toggleMenu()">
                        <span class="material-icons md-24 mr-1">menu_open</span>
                        hide menu
                    </a>
                    <a v-else class="nav-link click menu-items d-flex align-items-center justify-content-left" href="#"
                        @click="toggleMenu()">
                        <span class="material-icons md-24 mr-1">menu</span>
                        show menu
                    </a>
                    <Dark/>
                </nav>
                <nav id="mobileNav" class="navbar navbar-expand-sm  navbar-dark navbar-expand-md  justify-content-left">
                    <a class="navbar-brand"><img class="img-fluid" src="@/assets/logo.png"
                            width="120"></a>
                    <a class="nav-link click menu-items d-flex align-items-center justify-content-left" href="#"
                        @click="toggleMobile()">
                        <span class="material-icons md-24 mr-1">menu</span>
                        show menu
                    </a>
                    <Dark/>
                </nav>

                <div class="home container">
                    <div class="row" v-if="displayMessages">
                        <div class="col-md-12 text-center mt-5 mb-5">
                            <transition name="fade">
                                <span class="alert-danger" v-if="showErrorMessage">{{errorMessage}}</span>
                                <span class="alert-success" v-if="showSuccessMessage">{{successMessage}} </span>
                                <span class="alert-info" v-if="showInfoMessage">{{successInfo}}</span>
                            </transition>
                        </div>
                    </div>
                    <div class="row mt-5 mb-5">
                        <div class="col-md-12">
                            <div class="card">
                                <div class="card-body">
                                    <h5>Api id's control</h5>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p>Click on station id to copy.</p>
                                        </div>
                                        <div class="col-md-6">
                                            <input class="form-control form-control-sm"
                                                style="background-color: #3CBC8D !important;color: white !important;"
                                                type="text" id="inputCopy3" v-model="messageCopy" disabled></p>
                                        </div>
                                    </div>

                                    <vs-table>
                                        <template #thead>
                                            <vs-tr>
                                                <vs-th>
                                                    Station id
                                                </vs-th>
                                                <vs-th>
                                                    Name
                                                </vs-th>
                                                <vs-th>
                                                    Active
                                                </vs-th>
                                                <vs-th>
                                                    City
                                                </vs-th>
                                                <vs-th>
                                                    Country
                                                </vs-th>
                                            </vs-tr>
                                        </template>
                                        <template #tbody>
                                            <vs-tr :key="indextr" v-for="(tr, indextr) in apiIds" :data="tr">
                                                <vs-td>
                                                    <a class="click" style="text-decoration: underline;"
                                                        @click="doCopy(apiIds[indextr].station_id)">{{apiIds[indextr].station_id}}</a>
                                                </vs-td>

                                                <vs-td>
                                                    {{apiIds[indextr].station_name}}
                                                </vs-td>

                                                <vs-td>
                                                    <template v-if="apiIds[indextr].active">
                                                        <span class="green">Enabled</span>
                                                    </template>
                                                    <template v-else>
                                                        <span>Disabled</span>
                                                    </template>
                                                </vs-td>

                                                <vs-td>
                                                    {{apiIds[indextr].city}}
                                                </vs-td>

                                                <vs-td>
                                                    {{apiIds[indextr].country}}
                                                </vs-td>
                                            </vs-tr>
                                        </template>
                                    </vs-table>

                                
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import Navbar from "@/components/Navbar.vue";
    import Dark from "@/components/Dark.vue";
    import Mobilebar from "@/components/Mobilebar.vue";
    import { firebaseApp } from "../fb";
    import validator from "validator";
    import { sha256 } from 'js-sha256';
    import Sidebar from "@/components/Sidebar.vue";
    import axios from 'axios';
    export default {
        name: 'home',
        data() {
            return {
                displayMessages: false,
                showErrorMessage: false,
                errorMessage: null,
                showSuccessMessage: false,
                successMessage: null,
                showInfoMessage: false,
                successInfo: null,
                showBottomBar: true,
                showMobile: false,
                showLogo: false,
                showNav: false,
                url: '',
                apiNickname: '',
                user: '',
                name: '',
                apiObject: [],
                apiIds: [],
                apiObjectLength: 0,
                editName: '',
                editApi: '',
                editIndex: '',
                dbname: '',
                dbpass: '',
                dbuser: '',
                messageCopy: '',
                lvl: false,
                showCopy: false
            };
        },

        mounted() {
            this.getInitialData();
            this.getApiIds();

        },
        methods: {

            closeMobileBar(){
                this.showMobile=false
            },
            
            displayError(error) {
                var vm = this
                vm.displayMessages = true
                window.scrollTo({ top: 0, behavior: 'smooth' });
                if (vm.showErrorMessage) {
                    vm.showErrorMessage = false
                }
                vm.showErrorMessage = true
                vm.errorMessage = `❌${error}`
                setTimeout(() => {
                    vm.showErrorMessage = false
                    vm.displayMessages = false
                }, 3000);
            },

            displaySuccess(message) {
                var vm = this
                vm.displayMessages = true
                window.scrollTo({ top: 0, behavior: 'smooth' });
                if (vm.showSuccessMessage) {
                    vm.showSuccessMessage = false
                }
                vm.showSuccessMessage = true
                vm.successMessage = `✅${message}`
                setTimeout(() => {
                    vm.showSuccessMessage = false
                    vm.displayMessages = false
                }, 3000);
            },

            toggleMenu() {
                this.showBottomBar = !this.showBottomBar
                if (this.showBottomBar) {
                    this.showLogo = false
                } else {
                    this.showLogo = true
                }
            },

            toggleMobile() {
                // this.showMobile = !this.showMobile
                this.$router.push('/mobile');
            },



            doCopy: function (index) {
                var vm = this
                vm.showCopy = true
                var text = `${index}`;
                vm.messageCopy = text;
                setTimeout(() => {
                    var copyText = document.getElementById("inputCopy3");
                    copyText.select();
                    copyText.setSelectionRange(0, 99999); /*For mobile devices*/
                    document.execCommand("copy");
                    vm.displaySuccess("Copying to clipboard was successful");
                    vm.showCopy = false

                }, 600);
            },


            getApiIds() {
                var vm = this
                axios.get('https://quantumsync.org:3000/api/getApiIds')
                    .then(function (response) {
                        vm.apiIds = response.data
                        console.log(response.data)
                        return;
                    })
                    .catch(function (error) {
                        console.log(error)
                        vm.displayError(`Something went wrong ${error}`);
                        return;
                    })
            },


            getInitialData() {
                var vm = this
                firebaseApp.auth().onAuthStateChanged(function (user) {
                    if (!user) {
                        vm.$router.push('/');
                    } else {
                        vm.user = user.uid
                        firebaseApp.database().ref('users/' + user.uid).once("value", function (snapshot) {
                            var data = snapshot.val();
                            if (data.lvl == 0) {
                                vm.lvl = true
                            }
                            if (data.api) {
                                vm.apiObject = data.api
                                vm.apiObjectLength = vm.apiObject.length
                            }
                        }, function (errorObject) {
                            vm.displayError(
                                "Something went wrong"
                            );
                            return;
                        });
                    }
                });
            },

            logOut() {
                this.loading = false
                firebaseApp.auth().signOut()
            },
            sendNotify(title, text, color, icon) {
                this.$vs.notify({
                    title: title,
                    text: text,
                    color: color,
                    icon: icon
                });
                /*highlight_off error*/
            },
        },
        props: {
            msg: String
        },
        components: {
            Navbar,
            Dark,
            Mobilebar,
            Sidebar
        }
    }
</script>

<style>
    .collapse {
        display: hide !important;
    }

    .custom-bg {
        /* background: url('~@/assets/wall.jpg') !important; */
        background: linear-gradient(56deg, rgba(226, 255, 253, 1) 0%, rgba(255, 210, 215, 1) 100%) !important;

        -webkit-background-size: 100% !important;
        -moz-background-size: cover !important;
        -o-background-size: cover !important;
        background-size: cover !important;
        background-position: center center !important;
        background-repeat: no-repeat !important;
        background-attachment: fixed !important;
    }
</style>